
<ion-content (click)="startVideo()" >

  <div>
    <video id="video" autoplay preload="auto" muted loop webkit-playsinline playsinline class="bg-vid">
      <source src="assets/video/veggly.mov" type="video/webm">
      <source src="assets/video/veggly.mov" type="video/mp4">
    </video>
  </div>

  <div class="imgDiv">
    <img src="assets/imgs/logovegglyterms.svg" alt="Veggly Logo">
  </div>

  <div class="welcome"> 
    {{ 'welcomeToVeggly' | translate }}
  </div>

  <div class="findPeople">
    <p>{{ 'findPeople' | translate }}</p><br>
  </div>

  <div class="agreeText">
    {{ 'byClicking' | translate }} <b>{{ 'acceptAndContinue' | translate }}</b> {{ 'termsInstruction' | translate }}
  </div>

  <div class="termsURL">
    <a target="_blank" [href]="'https://' + ('termsURL' | translate)">
      {{ 'termsURL' | translate }}
    </a>
  </div>

  <div class="privacyText">

    {{ 'andPrivacyPolicy' | translate }}
  </div>

  <div class="privacyURL">
    <a target="_blank" [href]="'https://' + ('privacyURL' | translate)">{{ 'privacyURL' | translate }}</a>
  </div>

  <div class="acceptButton">
    <ion-button shape="round"  color="primary"  (click)="accept()">{{'acceptAndContinue' | translate}}</ion-button>
  </div>

</ion-content>

